module.exports = __webpack_public_path__ + "img/wohneinheit.1a0bc443.svg";